// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2Mfk9","options":"AnswerScale_options__3NzeN","selected":"AnswerScale_selected__1WiJd"};